import { Box, useTheme } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { LazyImage } from '~/components/LazyImage';
import { LazyVideo } from '~/components/LazyVideo';
import { contentType } from '~/types';
import { hexToRgbaString, isCarouselContent, isVideoAsset } from '~/utils';

import { CarouselIcon } from '../icons';

const propTypes = {
  alt: PropTypes.string,
  canPlayVideo: PropTypes.bool,
  contentPreviewedId: PropTypes.string,
  post: contentType,
};

const PostPreviewCard = ({
  alt = 'Post preview',
  canPlayVideo = false,
  contentPreviewedId,
  post,
  ...props
}) => {
  const theme = useTheme();
  const [asset] = post.assets || [];
  const isVideo = isVideoAsset(asset);

  const isCarousel = isCarouselContent(post);

  const renderIcon = () => {
    if (isCarousel) {
      return (
        <CarouselIcon
          boxSize="24px"
          position="absolute"
          color="white"
          right={{ base: 3, md: 5 }}
          top={{ base: 3, md: 5 }}
          filter={`drop-shadow( 1px 2px 6px ${hexToRgbaString(
            theme.colors.black,
            0.4,
          )}`}
          zIndex="1"
        />
      );
    }
  };

  return (
    <Box
      borderRadius={{ base: 'sm', sm: 'md', md: 'lg' }}
      overflow="hidden"
      position="relative"
      {...props}
    >
      {renderIcon()}
      {canPlayVideo && isVideo && !isCarousel ? (
        <LazyVideo
          containerProps={{ id: contentPreviewedId }}
          src={asset?.url}
          videoProps={{ alt, poster: asset.previewUrl }}
        />
      ) : (
        <LazyImage
          imageProps={{ alt, id: contentPreviewedId }}
          src={isVideo ? asset?.previewUrl : asset?.url}
        />
      )}
    </Box>
  );
};

PostPreviewCard.propTypes = propTypes;

export default PostPreviewCard;
